export enum SanityLanguage {
	csCZ = 'cs_CZ',
	skSK = 'sk_SK',
	huHU = 'hu_HU',
}
